import React from 'react'
import { priceStandardView, translate } from '../../utils/useful'
import SubformInput from './SubformInput';

class DebitCreditInput extends React.Component {

    state = {

        fields: [
            { key: 'account', type: 'SelectInput', col: '4', information: { label: '{{lang}}Account', address: 'getAccounts', groupBy: [{ key: 'type', options: [{ key: 'income', label: '{{lang}}Income' }, { key: 'expense', label: '{{lang}}Expense' }] }], fields: { title: 'name', value: '_id', type: 'type', }, type: 'api', isSearchable: true, placeholder: '{{lang}}Account', required: false } },
            { key: 'debit', type: 'PriceInput', col: '4', information: { label: '{{lang}}Debit', placeholder: '{{lang}}Debit', required: false, disabled: false, inplaceEditable: true, changeFunction: 'paymentValueChanged' }, showMain: true },
            { key: 'credit', type: 'PriceInput', col: '4', information: { label: '{{lang}}Credit', placeholder: '{{lang}}Credit', required: false, disabled: false, inplaceEditable: true, changeFunction: 'paymentValueChanged' }, showMain: true },
        ],

    }



    componentDidMount() {

        setTimeout(() => {
            this.createEntries()
        }, 10)
    }

    componentDidUpdate(prevProps, prevState) {

        let triggerKey = this.props.header?.information?.triggerKey
        let targetKey = this.props.header?.information?.targetKey

        if ((prevProps.fullData ? prevProps.fullData[triggerKey] : null) != (this.props.fullData ? this.props.fullData[triggerKey] : null)) {

            this.fetchInvoices()

        }


        if ((prevProps.fullData ? prevProps.fullData[targetKey] : null) != (this.props.fullData ? this.props.fullData[targetKey] : null)) {

            if (this.state.paymentValues['*'] != (this.props.fullData ? this.props.fullData[targetKey] : null)) {
                this.amountChanged((this.props.fullData ? this.props.fullData[targetKey] : null) ?? 0)
            }


        }


    }


    createEntries = () => {

        let entries = this.props.data ?? []
        // console.log("createEntries", entries)
        if (entries.length < 2) {
            let length = (2 - entries.length)
            for (let i = 0; i < length; i++) {
                entries.push({ account: null, debit: null, credit: null })
            }
        }


        this.calculateTotals(entries)
        this.props.changeValue(this.props.header.key, entries, this.props.extra)
    }



    focus = () => {
        this.input.focus()
    }


    validate = () => {

        let entries = this.props.data ?? []
        for (let i = 0; i < entries.length; i++) {
            const single = entries[i];
            if (single.account == null) {
                return '{{lang}}Account is required for all fields'
            }
        }

        if (this.state.different != 0) {
            return '{{lang}}Debit and Credit must be equal'
        }

        return null

    }





    functionsHandler = (type, name, data, extra, cb) => {

        if (this[name]) {
            this[name](data, extra, cb)
        }
    }




    changeValue = (key, value, extra) => {

        this.calculateTotals(value)
        this.props.changeValue(this.props.header?.key, value, this.props.extra)

    }


    calculateTotals = (entries) => {


        let debitTotal = 0
        let creditTotal = 0

        if (Array.isArray(entries)) {



            for (let i = 0; i < entries.length; i++) {
                const single = entries[i];
                if (single.debit) {
                    debitTotal += (single.debit ?? 0)
                }
                if (single.credit) {
                    creditTotal += (single.credit ?? 0)
                }
            }
        }

        let different = debitTotal - creditTotal

        this.setState({ debitTotal, creditTotal, different })

    }


    render() {

        return (
            <div className="w-100 h-100 flexc "  >
                <div className="pb-3 pt-0  w-100" >

                    <SubformInput header={{ information: { headers: this.state.fields } }} data={this.props.data} top={0} functionsHandler={this.functionsHandler} changeValue={this.changeValue}  inputClass={this.props.inputClass} variables={this.props.variables} params={this.props.params} width={this.props.width}/>


                    <div className="d-flex  justify-content-end mt-3 mb-4">
                        <div className="d-flex" style={{ backgroundColor: '#f6f6f6', borderRadius: 8, padding: '15px 20px' }}>
                            <div className="text-center" style={{ maxWidth: '250px', width: '100%', color: '#000' }}>
                                <p className="text-small text-end mb-2">{translate("Subtotal")}</p>
                                <p className="text-small text-end mb-2">{translate("Total")}</p>
                                <p className="text-small text-end mb-2" style={{ color: '#ee5050' }}>{translate("Difference")}</p>
                            </div>

                            <div className="text-center" style={{ width: '150px' }}>
                                <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.debitTotal)}</p>
                                <p className="text-small text-end mb-2">{priceStandardView(this.state.creditTotal)}</p>
                                {this.state.different < 0 && (
                                    <p className="text-small text-end mb-2" style={{ color: this.state.different != 0 ? '#ee5050' : '#000' }}>{priceStandardView(Math.abs(this.state.different))}</p>
                                )}
                            </div>


                            <div className="text-center" style={{ width: '150px' }}>
                                <p className="text-small text-end mb-2 text-bold">{priceStandardView(this.state.debitTotal)}</p>
                                <p className="text-small text-end mb-2">{priceStandardView(this.state.creditTotal)}</p>
                                {this.state.different >= 0 && (
                                    <p className="text-small text-end mb-2" style={{ color: this.state.different != 0 ? '#ee5050' : '#000' }}>{priceStandardView(this.state.different)}</p>
                                )}
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        )
    }
}

export default DebitCreditInput;